app.registerConstructor('CandidateFrontend', function() {

	this.resetUserExistsMessage = function () {
			 setTimeout(function () {	resetUserExists(); }, 500);
	};

	this.displayForgotPasswordLink = function () {
			if(jQuery('#forgottenPwd').length === 1) {
		  		jQuery("#legacyPasswordResetLink").css("display", "none");
					jQuery("#modalPasswordResetLink").css("display", "inline-block");
			}
  };

});
app.createVM('CandidateFrontend');
